import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

/*
  Delete corporate card connection

  @param companyId - Company ID
  @param connectionId - Connection ID to delete
 */
export default function purgeCorporateCardConnection(companyId: string, connectionId: number) {
  return API.patch<ResponseBase>(
    `/api/v2/companies/${companyId}/corporate-cards/connection/${connectionId}/purge`,
  );
}

export function depurgeCorporateCardConnection(companyId: string, connectionId: number) {
  return API.patch<ResponseBase>(
    `/api/v2/companies/${companyId}/corporate-cards/connection/${connectionId}/depurge`,
  );
}
